'use client';

type Retriever<T> = T | ((activity?: string) => Promise<T>);

export async function readThroughCache<T>(
  key: string,
  retriever: Retriever<T>,
  params?: { activity: string }
): Promise<T> {
  // Check if we're in the browser (client-side)
  if (typeof window === 'undefined') {
    // Server-side: just retrieve the data without caching
    if (typeof retriever === 'function') {
      return await (retriever as (activity?: string) => Promise<T>)(params?.activity);
    } else {
      return retriever;
    }
  }

  const ssData = window.sessionStorage.getItem(key);

  if (ssData && ssData !== 'undefined') {
    return JSON.parse(ssData);
  }

  let data: T;

  if (typeof retriever === 'function') {
    data = await (retriever as (activity?: string) => Promise<T>)(params?.activity);
  } else {
    data = retriever;
  }

  window.sessionStorage.setItem(key, JSON.stringify(data));
  return data;
}
